export const isZipFile = (file) => ["application/zip", "application/x-zip-compressed"].includes(file.type);
